// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_rcd","cls2":"LoggedOutDiscoveryPage-cls2_YkQ LoggedOutDiscoveryPage-cls1_rcd"};